import React from "react";
import  * as AiIcons from 'react-icons/ai';
import  * as IoIcons from 'react-icons/io';



export const SidebarData = [
    {
        title : 'Home',
        path : '/br',
        icons: <AiIcons.AiFillHome/>,
        cName: 'nav-text'
    },
    {
        title : 'Embaixadores',
        path : '/embaixadores',
        icons: <IoIcons.IoIosPaper/>,
        cName: 'nav-text'
    },
    {
        title : 'Time Sobr',
        path : '/timesobr',
        icons: <IoIcons.IoMdPeople/>,
        cName: 'nav-text'
    },
    {
        title : 'Termos e Políticas',
        path : '/termosepolitica',
        icons: <IoIcons.IoMdPeople/>,
        cName: 'nav-text'
    }


]